let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9QZrH")).then(() => parcelRequire('ay6y4'));